var _rect, _path, _path2, _circle, _circle2, _text, _text2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPython(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 320 200",
    role: "img",
    "aria-label": "Python logo badge",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 320,
    height: 200,
    rx: 22,
    fill: "#f7fbff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92 42h42c20 0 30 10 30 30v25H95c-23 0-38 15-38 38v4h48v-15h59v6c0 20-10 30-30 30H92c-20 0-30-10-30-30V72c0-20 10-30 30-30z",
    fill: "#3776ab"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122 158H80c-20 0-30-10-30-30v-25h69c23 0 38-15 38-38v-4h-48v15H50v-6c0-20 10-30 30-30h42c20 0 30 10 30 30v58c0 20-10 30-30 30z",
    fill: "#ffd343",
    opacity: 0.95
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92,
    cy: 65,
    r: 5,
    fill: "#fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 120,
    cy: 135,
    r: 5,
    fill: "#0b2f55"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 178,
    y: 92,
    fontFamily: "Arial, sans-serif",
    fontSize: 33,
    fontWeight: 800,
    fill: "#0b2f55"
  }, "PYTHON")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 180,
    y: 126,
    fontFamily: "Arial, sans-serif",
    fontSize: 18,
    fontWeight: 700,
    fill: "#52657c"
  }, "Mock Exam")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPython);
export default __webpack_public_path__ + "static/media/python.ac2c67a2facf05243328ed6c5fd20e89.svg";
export { ForwardRef as ReactComponent };